module.exports = __webpack_public_path__ + "img/upload.ffa1fc2c.svg";